// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.game-leaderboard-container {
  width: 100%;
}

.game-leaderboard-content {
  margin-top: 32px;
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-bottom: 32px !important;
}

.game-leaderboard-button {
  color: #fff !important;
  background-color: #00AAD1 !important;
  font-size: 12px !important;
  font-weight: 700 !important;
  height: 36px !important;
}
.game-leaderboard-button:hover {
  background-color: #00AAD1 !important;
}
@media (max-width: 900px) {
  .game-leaderboard-button {
    height: 23px;
  }
}
.game-leaderboard-button:disabled {
  background-color: rgba(0, 170, 209, 0.5) !important;
  color: rgba(255, 255, 255, 0.7) !important;
  cursor: not-allowed !important;
}

.game-leaderboard-title, .game-leaderboard-subtitle {
  font-size: 24px !important;
  font-weight: 700 !important;
  color: #002129 !important;
  text-align: center !important;
  margin-top: 12px !important;
}
@media (max-width: 900px) {
  .game-leaderboard-title, .game-leaderboard-subtitle {
    font-size: 16px !important;
  }
}

.game-leaderboard-trophy-container {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  gap: 16px;
  margin-top: 24px;
  margin-bottom: 8px;
}

.game-leaderboard-trophy-left {
  height: auto;
  width: 30px;
}
@media (max-width: 900px) {
  .game-leaderboard-trophy-left {
    width: 20px;
  }
}

.game-leaderboard-trophy-right {
  height: auto;
  width: 35px;
}
@media (max-width: 900px) {
  .game-leaderboard-trophy-right {
    width: 22px;
  }
}

.game-leaderboard-prize-text {
  font-size: 16px !important;
  font-weight: 700 !important;
  text-align: center !important;
}
@media (max-width: 900px) {
  .game-leaderboard-prize-text {
    font-size: 12px !important;
  }
}

.game-leaderboard-modal-link {
  font-size: 16px !important;
  font-weight: 700 !important;
  color: #00AAD1 !important;
  text-align: center !important;
  text-decoration: underline !important;
  cursor: pointer !important;
}
@media (max-width: 900px) {
  .game-leaderboard-modal-link {
    font-size: 12px !important;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/LeaderboardsPage/LeaderboardPages/GameLeaderboard.scss"],"names":[],"mappings":"AAEA;EACI,WAAA;AADJ;;AAIE;EACE,gBAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,8BAAA;AADJ;;AAIE;EACE,sBAAA;EACA,oCAAA;EACA,0BAAA;EACA,2BAAA;EACA,uBAAA;AADJ;AAGI;EACE,oCAAA;AADN;AAII;EAXF;IAYI,YAAA;EADJ;AACF;AAGI;EACE,mDAAA;EACA,0CAAA;EACA,8BAAA;AADN;;AAKE;EACE,0BAAA;EACA,2BAAA;EACA,yBAAA;EACA,6BAAA;EACA,2BAAA;AAFJ;AAII;EAPF;IAQI,0BAAA;EADJ;AACF;;AAIE;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,mBAAA;EACA,SAAA;EACA,gBAAA;EACA,kBAAA;AADJ;;AAIE;EACE,YAAA;EACA,WAAA;AADJ;AAGI;EAJF;IAKI,WAAA;EAAJ;AACF;;AAGE;EACE,YAAA;EACA,WAAA;AAAJ;AAEI;EAJF;IAKI,WAAA;EACJ;AACF;;AAEE;EACE,0BAAA;EACA,2BAAA;EACA,6BAAA;AACJ;AACI;EALF;IAMI,0BAAA;EAEJ;AACF;;AACE;EACE,0BAAA;EACA,2BAAA;EACA,yBAAA;EACA,6BAAA;EACA,qCAAA;EACA,0BAAA;AAEJ;AAAI;EARF;IASI,0BAAA;EAGJ;AACF","sourcesContent":["// GameLeaderboard.scss\n\n.game-leaderboard-container {\n    width: 100%;\n  }\n  \n  .game-leaderboard-content {\n    margin-top: 32px;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    margin-bottom: 32px !important;\n  }\n  \n  .game-leaderboard-button {\n    color: #fff !important; \n    background-color: #00AAD1 !important;\n    font-size: 12px !important;\n    font-weight: 700 !important;\n    height: 36px !important;\n    \n    &:hover {\n      background-color: #00AAD1 !important;\n    }\n    \n    @media (max-width: 900px) {\n      height: 23px;\n    }\n    \n    &:disabled {\n      background-color: rgba(0, 170, 209, 0.5) !important; // Lighter version of your blue\n      color: rgba(255, 255, 255, 0.7) !important;\n      cursor: not-allowed !important;\n    }\n  }\n  \n  .game-leaderboard-title, .game-leaderboard-subtitle {\n    font-size: 24px !important;\n    font-weight: 700 !important;\n    color: #002129 !important;\n    text-align: center !important;\n    margin-top: 12px !important;\n    \n    @media (max-width: 900px) {\n      font-size: 16px !important;\n    }\n  }\n  \n  .game-leaderboard-trophy-container {\n    display: flex;\n    flex-direction: row;\n    justify-content: center;\n    align-items: center;\n    gap: 16px;\n    margin-top: 24px;\n    margin-bottom: 8px;\n  }\n  \n  .game-leaderboard-trophy-left {\n    height: auto;\n    width: 30px;\n    \n    @media (max-width: 900px) {\n      width: 20px;\n    }\n  }\n  \n  .game-leaderboard-trophy-right {\n    height: auto;\n    width: 35px;\n    \n    @media (max-width: 900px) {\n      width: 22px;\n    }\n  }\n  \n  .game-leaderboard-prize-text {\n    font-size: 16px !important;\n    font-weight: 700 !important;\n    text-align: center !important;\n    \n    @media (max-width: 900px) {\n      font-size: 12px !important;\n    }\n  }\n  \n  .game-leaderboard-modal-link {\n    font-size: 16px !important;\n    font-weight: 700 !important;\n    color: #00AAD1 !important;\n    text-align: center !important;\n    text-decoration: underline !important;\n    cursor: pointer !important;\n    \n    @media (max-width: 900px) {\n      font-size: 12px !important;\n    }\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
